import { render } from "./FlashCards.vue?vue&type=template&id=40f89535"
import script from "./FlashCards.vue?vue&type=script&lang=js"
export * from "./FlashCards.vue?vue&type=script&lang=js"

import "./FlashCards.vue?vue&type=style&index=0&id=40f89535&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__